import React, { useState, useEffect, useRef } from "react";
import { Badge, Button, ButtonToolbar, Col, Divider, FlexboxGrid, Form, IconButton, Input, InputGroup, Loader, Message, Modal, Nav, Panel, Row, Schema, Stack, Table, Uploader, useToaster } from 'rsuite';
import axios from "axios";
import { useSelector } from 'react-redux';
import EyeIcon from '@rsuite/icons/legacy/Eye';
import EyeSlashIcon from '@rsuite/icons/legacy/EyeSlash';
import { logoff, passwordChange } from "services/oauth";

const styles = { width: 400, fontWeight: 'bold' };
const modelPW = Schema.Model({
    newpw: Schema.Types.StringType()
        .isRequired('Este campo es requerido.')
        .minLength(6, 'La contraseña debe contener al menos 6 caracteres')
        .containsLetter('La contraseña debe contener al menos una letra')
        .containsUppercaseLetter('La contraseña debe contener al menos un caracter en mayúscula')
        .containsLowercaseLetter('La contraseña debe contener al menos un caracter en minúscula')
        .containsNumber('La contraseña debe contener al menos un número')
        .addRule((value, data) => ['!', '*', '#', '$', '%', '&', '/', '(', ')', '=', '?',].some(x => value.indexOf(x) >= 0), 'La contraseña debe contener al menos un símbolo !*#$%&/()=?'),
    repeatpw: Schema.Types.StringType()
        .addRule((value, data) => value === data.newpw, 'The two passwords do not match')
        .isRequired('This field is required.'),
    currentpw: Schema.Types.StringType().isRequired('This field is required.'),
});
const messagePWChange = (
    <Message showIcon type="success" closable>
        La contraseña se actualizó correctamente.
    </Message>
);
const messagePWError = (
    <Message showIcon type="error" closable>
        No se pudo cambiar la contraseña.<br/>Contraseña actual incorrecta.
    </Message>
);
const messageDataChange = (
    <Message showIcon type="success" closable>
        Se actualizaron los datos de contacto correctamente.
    </Message>
);
const messageDataError = (
    <Message showIcon type="error" closable>
        Ocurrió un error al intentar actualizar los datos.
    </Message>
);

function Profile({ setWorking }) {
    const user = useSelector(state => state.auth.user)
    const site = useSelector(state => state.site);
    const apiURL = site.site.apiServer;
    const toaster = useToaster();

    const [pwCurrentVisible, setPWCurrentVisible] = React.useState(false);
    const [pwNewVisible, setPWNewVisible] = React.useState(false);
    const [pwRepeatVisible, setPWRepeatVisible] = React.useState(false);
    const formPWRef = React.useRef();
    const [formPWValue, setFormPWValue] = React.useState({ currentpw: '', newpw: '', repeatpw: '', });
    const handlePWSubmit = async () => {
        if (!formPWRef.current.check())
            return;
        if (await passwordChange({ UserName: user.email, CurrentPassword: formPWValue.currentpw, NewPassword: formPWValue.newpw })) {
            setFormPWValue({ currentpw: '', newpw: '', repeatpw: '', });
            toaster.push(messagePWChange, { placement: "topCenter", duration: 5000 });
            setTimeout(() => logoff(), 2000);
        } else {
            toaster.push(messagePWError, { placement: "topCenter", duration: 5000 });
        }
    };

    const formDataRef = React.useRef();
    const [formDataValue, setFormDataValue] = React.useState({ contact_name: '', contact_email: '', contact_phone: '', });
    const handleDataSubmit = async () => {
        setWorking(true);
        let fd = new FormData();
        fd.append('contact_name', formDataValue.contact_name);
        fd.append('contact_email', formDataValue.contact_email);
        fd.append('contact_phone', formDataValue.contact_phone);
        await axios
            .postForm(`${apiURL}/usuario`, fd, {
                token: JSON.parse(atob(localStorage.getItem("token"))).at, 'Content-Type': 'multipart/form-data',
            })
            .then((response) => {
                if (response.data.result)
                    toaster.push(messageDataChange, { placement: "topCenter", duration: 5000 });
                else
                    toaster.push(messageDataError, { placement: "topCenter", duration: 5000 });
            })
            .catch((e) => {
                console.log(e);
                toaster.push(messageDataError, { placement: "topCenter", duration: 5000 });
            })
            .finally(() => {
                setWorking(false);
            });
    }

    const fetchData = async () => {
        await axios
            .get(apiURL + "/usuario", { headers: { token: JSON.parse(atob(localStorage.getItem("token"))).at }, })
            .then((response) => {
                if (response.data && response.data.result && response.data.result.length > 0) {
                    setFormDataValue({
                        contact_name: response.data.result[0].contactName,
                        contact_email: response.data.result[0].contactEmail,
                        contact_phone: response.data.result[0].contactPhone,
                    });
                }
            })
            .catch((e) => { console.log(e) });
    }

    useEffect(() => {
        console.log('Profile begin');
        console.log(user);
        fetchData();
        return () => { console.log('Profile end'); }
    },[])


    return (
        <Panel header={<Stack alignItems="baseline" spacing={10}>
            <Stack.Item grow={1}>
                <h4 className="title">Perfil de usuario</h4>
            </Stack.Item>
        </Stack>} bordered>
            <FlexboxGrid justify="space-around">
                <FlexboxGrid.Item as={Col} colspan={24} md={11}>
                    <Panel header={<Stack alignItems="baseline" spacing={10}>
                        <Stack.Item grow={1}>
                            <h5 className="title">Datos de contacto</h5>
                        </Stack.Item>
                    </Stack>} bordered shaded>
                        <Stack spacing={6} justifyContent="center">
                            <Form ref={formDataRef} onChange={setFormDataValue} formValue={formDataValue}>
                                <Form.Group controlId="data-contact_name">
                                    <Form.ControlLabel>Nombre</Form.ControlLabel>
                                    <InputGroup inside style={styles}>
                                        <Form.Control name="contact_name" type='text' />
                                    </InputGroup>
                                </Form.Group>
                                <Form.Group controlId="data-contact_email" style={{ display: 'none' }}>
                                    <Form.ControlLabel>Dirección de correo</Form.ControlLabel>
                                    <InputGroup inside style={styles}>
                                        <Form.Control name="contact_email" type='text' />
                                    </InputGroup>
                                </Form.Group>
                                <Form.Group controlId="data-contact_phone">
                                    <Form.ControlLabel>Tel&eacute;fonos de contacto</Form.ControlLabel>
                                    <InputGroup inside style={styles}>
                                        <Form.Control name="contact_phone" type='text' />
                                    </InputGroup>
                                </Form.Group>
                                <ButtonToolbar>
                                    <Button appearance="primary" onClick={handleDataSubmit}>
                                        Actualizar datos
                                    </Button>
                                </ButtonToolbar>
                            </Form>
                        </Stack>
                    </Panel>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24}  md={11}>
                    <Panel header={<Stack alignItems="baseline" spacing={10}>
                        <Stack.Item grow={1}>
                            <h5 className="title">Reestablecer contraseña</h5>
                        </Stack.Item>
                    </Stack>} bordered shaded>
                        <Stack spacing={6} justifyContent="center">
                            <Form model={modelPW} ref={formPWRef} onChange={setFormPWValue} formValue={formPWValue}>
                                <Form.Group controlId="pw-current">
                                    <Form.ControlLabel>Contraseña actual</Form.ControlLabel>
                                    <InputGroup inside style={styles}>
                                        <Form.Control name="currentpw" type={pwCurrentVisible ? 'text' : 'password'} />
                                        <InputGroup.Button tabIndex="-1" onClick={() => setPWCurrentVisible(!pwCurrentVisible)}>{pwCurrentVisible ? <EyeIcon /> : <EyeSlashIcon />}</InputGroup.Button>
                                    </InputGroup>
                                </Form.Group>
                                <Form.Group controlId="pw-new">
                                    <Form.ControlLabel>Contraseña nueva</Form.ControlLabel>
                                    <InputGroup inside style={styles}>
                                        <Form.Control name="newpw" type={pwNewVisible ? 'text' : 'password'} autoComplete="off" />
                                        <InputGroup.Button tabIndex="-1" onClick={() => setPWNewVisible(!pwNewVisible)}>{pwNewVisible ? <EyeIcon /> : <EyeSlashIcon />}</InputGroup.Button>
                                    </InputGroup>
                                </Form.Group>
                                <Form.Group controlId="pw-repeat">
                                    <Form.ControlLabel>Verificar contraseña</Form.ControlLabel>
                                    <InputGroup inside style={styles}>
                                        <Form.Control name="repeatpw" type={pwRepeatVisible ? 'text' : 'password'} autoComplete="off" />
                                        <InputGroup.Button tabIndex="-1" onClick={() => setPWRepeatVisible(!pwRepeatVisible)}>{pwRepeatVisible ? <EyeIcon /> : <EyeSlashIcon />}</InputGroup.Button>
                                    </InputGroup>
                                </Form.Group>
                                <ButtonToolbar>
                                    <Button appearance="primary" onClick={handlePWSubmit}>
                                        Reestablecer
                                    </Button>
                                </ButtonToolbar>
                            </Form>
                        </Stack>                        
                    </Panel>
                </FlexboxGrid.Item>
            </FlexboxGrid>
        </Panel>
    );

}
export default Profile;